import React, { useEffect, useState } from 'react';
import './VideoPrompt.css'; // Asegúrate de que este archivo tenga las clases actualizadas
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import ButtonSidebar from '../ButtonSidebar/ButtonSidebar';
import { useHistory } from 'react-router-dom';
import arrowSVG from '../Iconos/arrow.svg';
import playSVG from '../Iconos/play.svg';
import VideoPreview from './VideoPreview'; // Importa el nuevo componente

const VALID_MINUTES = 35; // Los videos se guardan por 35 minutos

function VideoPrompt() {
  const history = useHistory();
  const { t } = useTranslation();
  const [prompt, setPrompt] = useState('');
  const [selectedVideo, setSelectedVideo] = useState<string>('');
  const [selectedVideoIndex, setSelectedVideoIndex] = useState<number>(0);
  const [videoThumbnails, setVideoThumbnails] = useState<string[]>([]);
  const [videoUrls, setVideoUrls] = useState<string[]>([]);
  const [isGenerating, setIsGenerating] = useState(false);
  const [progress, setProgress] = useState(0); // Estado para el progreso de la barra
  const DescribeVideo = t('DescribeVideo');
  const userId = localStorage.getItem('userId') || 'defaultUserId';
  const [isVideoCombined, setIsVideoCombined] = useState(false);
  const [combinedVideoPath, setCombinedVideoPath] = useState('');
  
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsGenerating(true);
    setProgress(0);
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';
      const response = await axios.post(`${backendUrl}/api/videos`, {
        query: prompt,
      });

      if (response.data.videos && response.data.videos.length) {
        const videos = response.data.videos;
        // Extraer las URLs de los videos y miniaturas
        const videoUrls = videos.map((video: any) => video.video_files[0].link);
        const thumbnails = videos.map((video: any) => video.image);

        const videoData = {
          timestamp: new Date().getTime(),
          videos: videoUrls,
          thumbnails: thumbnails,
        };
        localStorage.setItem('videoData', JSON.stringify(videoData));
        setVideoThumbnails(thumbnails);
        setVideoUrls(videoUrls);
        setSelectedVideo(videoUrls[0]);
        setSelectedVideoIndex(0);
      } else {
        console.error('No videos returned from the API');
      }
    } catch (error) {
      console.error('Error fetching videos:', error);
    } finally {
      setIsGenerating(false);
    }
  };


  useEffect(() => {
    // Verificar si el usuario está autenticado
    const userId = localStorage.getItem('userId');
    if (!userId) {
      // Redirigir a la página de inicio de sesión si no está autenticado
      history.push('/PantallaInicial');
    }
  }, [history]);

  useEffect(() => {
    const videoDataJSON = localStorage.getItem('videoData');
    if (videoDataJSON) {
      const videoData = JSON.parse(videoDataJSON);
      const timeNow = new Date().getTime();
      const timeElapsed = (timeNow - videoData.timestamp) / 1000 / 60; // Tiempo en minutos

      if (timeElapsed < VALID_MINUTES) {
        setVideoThumbnails(videoData.thumbnails);
        setVideoUrls(videoData.videos);
        setSelectedVideo(videoData.videos[0]);
        setSelectedVideoIndex(0);
      } else {
        localStorage.removeItem('videoData'); // Videos expirados
      }
    }
  }, []);

  useEffect(() => {
    if (isGenerating) {
      const interval = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress >= 100) {
            clearInterval(interval);
            return 100;
          }
          return prevProgress + 1.67; // Incremento del progreso para completar en 60 segundos (100 / 60 ≈ 1.67)
        });
      }, 1000); // Actualizar cada segundo
    }
  }, [isGenerating]);

  const handleSelectVideo = (index: number) => {
    setSelectedVideo(videoUrls[index]);
    setSelectedVideoIndex(index);
    localStorage.setItem('selectedVideo', videoUrls[index]);
  };

  const handlePreviousClick = () => {
    history.push('/');
  };

  const handleNextClick = () => {
    history.push('/Social-Networking2');
  };

  const handleSaveDraft = async (videoUrl: string) => {
    const token = localStorage.getItem('token'); // Se asume que el token se guarda en localStorage
    if (!token) {
      alert('No estás autenticado.');
      return;
    }

    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001'; // En desarrollo puedes usar localhost por defecto

      console.log(backendUrl);

      await axios.post(
        `${backendUrl}/save-drafts`,
        {
          userId,
          videos: [videoUrl],
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
      );
      alert('Borrador guardado con éxito');
    } catch (error) {
      console.error('Error al guardar el borrador:', error);
      alert('Error al guardar el borrador');
    }
  };

  const handleCombineVideos = async () => {
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';
      const videoDataJSON = localStorage.getItem('videoData');
      if (videoDataJSON) {
        const videoData = JSON.parse(videoDataJSON);
        const response = await axios.post(
          `${backendUrl}/combine-videos`,
          {
            videoUrls: videoData.videos,
          }
        );
  
        // Actualizar el estado con la ruta del video combinado
        setCombinedVideoPath(response.data.videoPath);
        setSelectedVideo(response.data.videoPath);
        setIsVideoCombined(true);
      }
    } catch (error) {
      console.error('Error combining videos:', error);
      alert('Error combining videos.');
    }
  };
  
  
  const handleAddVoiceover = async () => {
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';
      const response = await axios.post(
        `${backendUrl}/add-voiceover`,
        {
          videoPath: combinedVideoPath,
          prompt: prompt,
        },
        {
          responseType: 'blob',
        }
      );
  
      // Crear una URL para el video recibido
      const videoBlob = new Blob([response.data], { type: 'video/mp4' });
      const videoUrl = URL.createObjectURL(videoBlob);
      setSelectedVideo(videoUrl);
  
      // Opcional: Actualizar el estado o mostrar un mensaje al usuario
    } catch (error) {
      console.error('Error adding voiceover:', error);
    }
  };
  
  return (
    <div className='videocreativo-container-text'>

      <div className="videocreativo-video-and-thumbnails">

        <VideoPreview
          thumbnails={videoThumbnails}
          onSelect={handleSelectVideo}
          selectedVideoIndex={selectedVideoIndex}
        />
      </div>
      <div className='videocreativo-video-container'>

        <div className="videocreativo-video-prompt-container">
          <div className="videocreativo-video-prompt-title">
            <p>
              Describe el tema del{' '}
              <span className="videocreativo-highlight"> video</span>.
            </p>
          </div>
          <div className="videocreativo-video-prompt-description">
            <form onSubmit={handleSubmit}>
              <input
                className='videocreativo-input-prompt'
                value={prompt}
                onChange={(e) => setPrompt(e.target.value)}
                placeholder={DescribeVideo}
              ></input>
              <button className="videocreativo-video-prompt-button" type="submit">
                <span className="videocreativo-video-prompt-button-icon">
                  <img src={playSVG} alt="" />
                </span>
                CREAR
              </button>
            </form>
          </div>
          {isGenerating && (
            <div className="videocreativo-loading-container">
              <div className="videocreativo-loading-indicator">{t('Generando videos...')}</div>
              <div className="videocreativo-progress-bar">
                <div className="videocreativo-progress-bar-fill" style={{ width: `${progress}%` }}></div>
              </div>
            </div>
          )}
          <div className="videocreativo-main-video-container">
            {selectedVideo && (
              <video controls src={selectedVideo} className="videocreativo-main-video" />
            )}
            <button className="videocreativo-combine-button" onClick={handleCombineVideos}>
              {t('Combinar Videos')}
            </button>
            <button className="videocreativo-add-voiceover-button" onClick={handleAddVoiceover} disabled={!isVideoCombined}>
              {t('Agregar Voz en Off')}
            </button>

            <div className="videocreativo-video-selection-navigation">
              <button className="videocreativo-video-selection-previous" onClick={handlePreviousClick}>
                <img src={arrowSVG} alt="" className='videocreativo-reverse-arrow' /> {t('Anterior')}
              </button>
              <button className="videocreativo-video-selection-next" onClick={handleNextClick}>
                {t('Siguiente')} <img src={arrowSVG} alt="" className='videocreativo-normal-arrow' />
              </button>
            </div>
          </div>
        </div>
      </div>
      <ButtonSidebar selectedImage={selectedVideo} onSaveDraft={handleSaveDraft} onCropClick={function (): void {
        throw new Error('Function not implemented.');
      } } />
    </div>
  );
}

export default VideoPrompt;
